import Dashboard from "@/Pages/Student/Dashboard";
import CompletedCourses from "@/Pages/Student/CompletedCourses";
import AssignmentIndex from "@/Pages/Student/Assignment/Index";
import AssignmentEdit from "@/Pages/Student/Assignment/Edit";

export default [
    {
        path: '/dashboard',
        component: Dashboard,
        name: 'student.dashboard',
        meta: {
            auth: true
        }
    },
    {
        path: '/completed-courses',
        component: CompletedCourses,
        name: 'courses.completed',
        meta: {
            auth: true
        }
    },
    {
        path: '/assignments',
        component: AssignmentIndex,
        name: 'student.assignments',
        meta: {
            auth: true
        }
    },
    {
        path: '/certificates',
        component: AssignmentIndex,
        name: 'student.certificates',
        meta: {
            auth: true,
            isCertificate: true
        }
    },
    {
        path: '/assignments/edit/:assignmentId?',
        component: AssignmentEdit,
        name: 'student.assignments.edit',
        meta: {
            auth: true
        }
    },
    {
        path: '/certificates/edit/:assignmentId?',
        component: AssignmentEdit,
        name: 'student.certificates.edit',
        meta: {
            auth: true,
            isCertificate: true
        }
    },
];
